import * as Sentry from '@sentry/react';

export const setUser = ({ id, email, first_name, last_name }: Sentry.User) => {
  Sentry.setUser({
    id,
    email,
    name: `${first_name} ${last_name}`,
  });
};

export const notify = <T = Error>(error: T) => {
  Sentry.captureException(error);
};

export const warn = (message: string) =>
  Sentry.captureMessage(message, 'warning');
